import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';

/**
 * Thin wrapper so class components can use the @react-oauth/google hook.
 * onSuccess receives a plain userinfo object: { email, name, given_name, family_name, picture, sub }
 */
export default function GoogleSignInButton({ onSuccess, onError, className, children }) {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        if (!res.ok) {
          throw new Error(`Google userinfo request failed with status ${res.status}`);
        }
        const profile = await res.json();
        if (!profile || !profile.email) {
          throw new Error('Google did not return an email address for this account.');
        }
        onSuccess(profile);
      } catch (e) {
        console.error('Google userinfo fetch failed', e);
        if (onError) onError(e);
      }
    },
    onError: (err) => {
      console.error('Google login error', err);
      if (onError) onError(err);
    },
  });

  return (
    <button type="button" className={className} onClick={() => login()}>
      {children}
    </button>
  );
}
